import { useNavigate } from "react-router-dom"
import { makeStyles } from "tss-react/mui"
import {
    TENANT_USERS_CREATE_ADMIN_ROUTE,
    TENANT_USERS_CREATE_USER_ROUTE,
    getTenantUsersRoute,
} from "../../../../constants/routes"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { AdminHomeCardGroup, AdminHomeCardGroups } from "../../../admin/components/AdminHomeCard"
import { TenantHomeCard } from "../components/TenantHomeCard"

const useStyles = makeStyles()((_theme) => ({
    page: {
        paddingTop: "3rem",
    },
}))

export function TenantAdminHome() {
    const { classes } = useStyles()
    const navigate = useNavigate()

    return (
        <div className={classes.page}>
            <AdminHomeCardGroups>
                <LocalizedStrict id="office-manager-home-user-card-group" attrs={{ title: true }}>
                    <AdminHomeCardGroup title="Users">
                        <LocalizedStrict
                            id="office-manager-home-user-card"
                            attrs={{ title: true, description: true }}
                        >
                            <TenantHomeCard
                                title="Users"
                                description="Manager your users"
                                onCreateClick={() => navigate(TENANT_USERS_CREATE_USER_ROUTE)}
                                onShowAllClick={() => navigate(getTenantUsersRoute("user"))}
                            />
                        </LocalizedStrict>
                        <LocalizedStrict
                            id="office-manager-home-admin-card"
                            attrs={{ title: true, description: true }}
                        >
                            <TenantHomeCard
                                title="Administrators"
                                description="Manager your administrators"
                                onCreateClick={() => navigate(TENANT_USERS_CREATE_ADMIN_ROUTE)}
                                onShowAllClick={() => navigate(getTenantUsersRoute("admin"))}
                            />
                        </LocalizedStrict>
                    </AdminHomeCardGroup>
                </LocalizedStrict>
            </AdminHomeCardGroups>
        </div>
    )
}
